export const teamTag = {
	PAGE_THEME_ENABLED: false,
};
